import { styled } from '@mui/material/styles';

import { Theme, px, rem } from '../../theme';
import { Paragraph } from '../Paragraph';

import {
    StyledListProperties,
    StyledHeadingWrapperProperties,
    StyledStyledListContentProperties,
} from './BenefitsTable.types';

export const StyledHeadingWrapper = styled(
    'div',
)<StyledHeadingWrapperProperties>`
    ${({
        theme,
        $align,
    }: StyledHeadingWrapperProperties & { theme: Theme }) => `
        padding: ${theme.tggSpacing([0, px(15)], [0, 4])};
        ${theme.breakpoints.up('desktop')} {
            padding: ${
                $align === 'left'
                    ? `0 ${theme.pxToRem(30)}`
                    : `0 ${theme.pxToRem(30)} 0 20rem `
            };
        }
	`}
`;

export const StyledHeading = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => `
         padding: ${theme.tggSpacing([px(10), 0], [2.5, 0])};
        font-family: thegymgroupsans-Headline;
	`}
`;

export const StyledList = styled('div')<StyledListProperties>`
    & > div:nth-of-type(6n + 1),
    & > div:nth-of-type(6n + 2),
    & > div:nth-of-type(6n + 3) {
        background-color: ${({ $backgroundColor }) => $backgroundColor};
    }
`;

export const StyledListContent = styled(
    'div',
)<StyledStyledListContentProperties>`
    ${({
        theme,
        $align,
    }: StyledStyledListContentProperties & { theme: Theme }) => `
        /* stylelint-disable unit-allowed-list */
        display: flex;
        padding: ${theme.tggSpacing(rem(1.5), 3.75)};
        ${theme.breakpoints.up('desktop')} {
            padding: ${
                $align === 'left'
                    ? theme.tggSpacing(
                          [rem(1.5), rem(1.5), rem(1.5), rem(3)],
                          [6, 6, 6, 12],
                      )
                    : theme.tggSpacing(
                          [rem(1.5), rem(1.5), rem(1.5), rem(20)],
                          [6, 6, 6, 80],
                      )
            };
        }
	`}
`;

export const StyledIconContainer = styled('span')`
    ${({ theme }: { theme: Theme }) => `
        width: ${theme.tggSpacing(rem(2.2), 9)};
    height: ${theme.tggSpacing(rem(2.2), 9)};
	`}
`;

export const StyledParagraph = styled(Paragraph)`
    display: inline-block;
    padding-left: ${({ theme }: { theme: Theme }) =>
        theme.tggSpacing(rem(0.625), 1.5625)};
`;
